import { useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import {
    Select, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function TransferSelect({
    users, 
    closeIt, 
    handleSubmit, 
}){
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const [approver, setApprover] = useState({});
    //--------------------------------------------------------------------------------------------
    return (
        <Modal
            closeIt = {closeIt}
            title = "Forward Approval"
            width = {300}
            handleFormSubmit = {handleSubmit}
            actionKey = "Forward"
        >
            <Select
                className = "m-3"
                options = {
                    users
                    .filter(thisUser => 
                        thisUser.purchases === "approver" && thisUser.email !== user.email
                    ).map(thisUser => ({label: thisUser.userName, value: thisUser.email}))
                } 
                onChange = {e => {setApprover(e)}}
            />
            <input
                className = "nodisplay" readOnly
                name = "forward" value = {JSON.stringify(approver)}
            />
        </Modal>
    )
}